import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import FundBtnType from "../../../../enums/fund-button-type";
@Component({
    selector: 'fund-page-buttons',
    templateUrl: './fund-page-buttons.component.html',
    styleUrls: ['./fund-page-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FundPageButtonsComponent {
  @Input() barType: FundBtnType = FundBtnType.FUND
  @Output() addFund = new EventEmitter<any>();
  @Output() addCertificated = new EventEmitter<any>();
  @Output() navigateToReviewTimeline = new EventEmitter<any>();

  protected readonly FundBtnType = FundBtnType;

  onAddFundClick(){
    this.addFund.emit()
  }

  onAddCertificatedClick(){
    this.addCertificated.emit()
  }

  onNavigateToReviewTimeline(){
    this.navigateToReviewTimeline.emit()
  }
}
